module.exports = __webpack_public_path__ + "img/realestate_pf_overview_icon02.483dc548.svg";